import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Container } from 'react-bootstrap';
import GrupoDetalle from './GrupoDetalles';
import GrupoEmpresa from './empresa/Empresa';
import GrupoProveedor from './proveedor/GrupoProveedor';
import GrupoContacto from './contactos/GrupoContacto';
import ServicioAsignado from './servicio/ServicioAsignado';
import ProfaseDataGrid from '../../commons/Datagrid';

import { getEntities } from '../empresa.reducer';
import { useAppDispatch, useAppSelector } from '../../store';
import { Link } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import GrupoCrearModal from './GrupoCrearModal';

interface Empresa {
    id: number;
    razonSocial: string;
}

function EmpresaTable() {

    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const location = useLocation();

    const [rows, setRows] = useState<any>([]);

    const empresaList = useAppSelector(state => state.empresa.entities);
    const loading = useAppSelector(state => state.empresa.loading);
    const totalItems = useAppSelector(state => state.empresa.totalItems);


    console.log('App loading');

    useEffect(() => {

    }, [])

    useEffect(() => {
        console.log('empresa list', empresaList);
        if (empresaList != null)
            setRows(empresaList.map((e: any) => ({
                ...e,
                'grupoEmpresarial.alias': e.grupoEmpresarial.alias,
                'acciones': e.id
            })));
    }, [empresaList])


    const filters = [
        {
            label: 'Grupo',
            name: 'grupo'
        },
        {
            label: 'RFC',
            name: 'rfc'
        },
        {
            label: 'Empresa',
            name: 'razonSocial'
        },
        {
            label: 'Activo',
            name: 'grupo.activo'
        }
    ]

    const seleccionarGrupo = (params: any) => {
        console.log('Seleccionar params', params.row.grupoEmpresarial);
        navigate(`/empresas/grupo/${params.row.grupoEmpresarial.id}`);
    }
    const seleccionarEmpresa = (params: any) => {
        console.log('Seleccionar params', params.row.id);
        navigate(`/empresas/grupo/${params.row.grupoEmpresarial.id}/empresa/${params.row.id}`);
    }

    const renderButtonsCell = (params: any) => {
        return <>
            <button className="btn btn-primary" onClick={() => { seleccionarEmpresa(params); }}>Seleccionar</button>
        </>
    };
    const renderEmpresaCell = (params: any) => {
        return <>
            <Link
                component="button"
                variant="body2"
                onClick={() => { seleccionarEmpresa(params) }}
            // onClick={() => handleCellFilter(column.name, params.value?.toString() || "")}
            >
                {params.value?.toString()}
            </Link>
        </>
    };
    const renderGrupoCell = (params: any) => {
        return <>
            <Link
                component="button"
                variant="body2"
                onClick={() => { seleccionarGrupo(params) }}
            // onClick={() => handleCellFilter(column.name, params.value?.toString() || "")}
            >
                {params.value?.toString()}
            </Link>
        </>
    };
    const cols = [
        { field: "id", headerName: "ID", flex: 1 },
        { field: "grupoEmpresarial.alias", headerName: "Grupo", flex: 2, renderCell: renderGrupoCell },
        { field: "rfc", headerName: "RFC", flex: 2, renderCell: renderEmpresaCell },
        { field: "razonSocial", headerName: "Razón Social", flex: 4, width: 200, renderCell: renderEmpresaCell },
        { field: "", headerName: "", flex: 2, renderCell: renderButtonsCell },
    ];

    const fetchData = async (params: any) => {
        console.log('fetch', params);
        dispatch(getEntities(params));
    };

    const crearGrupoOpen = location.pathname === '/empresas/grupo/new';

    const cerrarCrearGrupo = () => {
        navigate('/empresas');
    };

    return (

        <div className="p-3">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
                <button
                    type="button"
                    className="btn btn-primary d-inline-flex align-items-center gap-2"
                    onClick={() => navigate('/empresas/grupo/new')}
                >
                    <FaPlus /> Crear Grupo
                </button>
            </div>
            <ProfaseDataGrid
                cols={cols}
                title={'Empresas'}
                filters={filters}
                fetch={fetchData}
                rowCount={totalItems}
                loading={loading}

                rows={rows}
            ></ProfaseDataGrid>

            <GrupoCrearModal
                open={crearGrupoOpen}
                onClose={cerrarCrearGrupo}
                onCreated={(id) => navigate(`/empresas/grupo/${id}`)}
            />
        </div >
    );
}

export default EmpresaTable;
